
import { mapGetters } from "vuex";
import {
  clearMultiEmpresaReportSelection,
  setMultiEmpresaReportSelection,
} from "@/modules/Relatorios/services/reportGeneration";

export default {
  name: "RelatorioEmpresasSelector",
  data() {
    return {
      selecionadas: [],
    };
  },
  computed: {
    ...mapGetters(["empresas", "empresaContexto"]),
    empresaAtualId() {
      return Number(this.empresaContexto?.id_empresa || 0);
    },
    grupoAtualId() {
      return Number(this.empresaContexto?.id_grupo_empresa || 0);
    },
    empresasDoGrupo() {
      if (!this.grupoAtualId) return [];

      return (this.empresas || [])
        .filter(
          (empresa) =>
            Number(empresa.id_grupo_empresa || 0) === this.grupoAtualId
        )
        .sort((a, b) => this.nomeEmpresa(a).localeCompare(this.nomeEmpresa(b)));
    },
    visivel() {
      return this.empresasDoGrupo.length > 1;
    },
    resumoSelecao() {
      if (this.selecionadas.length === this.empresasDoGrupo.length) {
        return `Todas as empresas (${this.selecionadas.length})`;
      }

      if (this.selecionadas.length === 1) {
        const empresa = this.empresasDoGrupo.find(
          (item) => Number(item.id_empresa) === Number(this.selecionadas[0])
        );
        return this.nomeEmpresa(empresa);
      }

      return `${this.selecionadas.length} empresas selecionadas`;
    },
  },
  watch: {
    empresaAtualId: {
      immediate: true,
      handler(idEmpresa) {
        this.selecionadas = idEmpresa ? [idEmpresa] : [];
        this.atualizarContexto();
      },
    },
  },
  beforeDestroy() {
    clearMultiEmpresaReportSelection();
  },
  methods: {
    nomeEmpresa(empresa) {
      return empresa?.nome_fantasia || empresa?.nome || "Empresa";
    },
    selecionarTodas() {
      this.selecionadas = this.empresasDoGrupo.map((empresa) =>
        Number(empresa.id_empresa)
      );
      this.atualizarContexto();
    },
    atualizarContexto() {
      this.$nextTick(() => {
        if (!this.selecionadas.length && this.empresaAtualId) {
          this.selecionadas = [this.empresaAtualId];
        }

        setMultiEmpresaReportSelection(this.selecionadas);
      });
    },
  },
};
